module.exports = __webpack_public_path__ + "img/fendanyun_06.f53794b9.jpg";